import React, { useState, useEffect } from "react";
import Sidebar from "../../commons/Sidebar/Sidebar";
import Header from "../../commons/Header/Header";
import { useLocation } from "react-router-dom";
import RestaurantList from "./RestaurantList/RestaurantList";
import "notosans-fontface/css/notosans-fontface.css";
import PendingRestaurant from "./PendingRestaurant/PendingRestaurant";
import RejectedRestaurant from "./RejectedRestaurant/RejectedRestaurant";

function MenuAndRestaurantManagement() {
  const location = useLocation();
  const [cms, setCms] = useState({
    type: "restaurant_list",
  });
  const [listState, setListState] = useState(null);

  useEffect(() => {
    const state = location?.state;
    if (!state) return;

    if (typeof state === "string") {
      setCms({ type: state });
      setListState(null);
      return;
    }

    if (state.type || state.listState?.tabType) {
      setCms({ type: state.type || state.listState.tabType });
    }
    if (state.listState) {
      setListState(state.listState);
    }
  }, [location.state]);

  return (
    <>
      <div className="container-scroller">
        <Header />
        <div className="container-fluid page-body-wrapper">
          <Sidebar status={true} />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="heading mb-4">
                <h3 className="text-default weight-400">Menu And Restaurant Management</h3>
              </div>
              <div className="row mx-0 main-content-body">
                <div className="col-md-12 mb-26 px-0 mt-0 d-flex">
                  <ul
                    className="nav common-tabs cms-tabs table-inline"
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item mr-3">
                      <a
                        className={`nav-link br-10 w-auto mx-0 text-center ${
                          cms.type === "restaurant_list" ? "active" : undefined
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setCms({ type: "restaurant_list" });
                          setListState(null);
                        }}
                      >
                        Restaurant List
                      </a>
                    </li>
                    <li className="nav-item mr-3">
                      <a
                        className={`nav-link br-10 w-auto mx-0 text-center ${
                          cms.type === "pending_restaurant" ? "active" : undefined
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setCms({ type: "pending_restaurant" });
                          setListState(null);
                        }}
                      >
                        Pending Restaurant
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link br-10 w-auto mx-0 text-center ${
                          cms.type === "rejected_restaurant" ? "active" : undefined
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setCms({ type: "rejected_restaurant" });
                          setListState(null);
                        }}
                      >
                       Rejected Restaurant
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-md-12 tab-content row px-0 mx-0 mt-4">
                  {cms.type === "restaurant_list" ? (
                    <RestaurantList listState={listState} />
                  ) : cms.type === "pending_restaurant" ? (
                    <PendingRestaurant listState={listState} />
                  ) : cms.type === "rejected_restaurant" ? (
                    <RejectedRestaurant/>
                  ) : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MenuAndRestaurantManagement;
